import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M219.029412,0 L219.029412,225.882353 L219.029412,338.823529 L219.029412,464.313725 L162.514706,464.313725 C131.318588,464.313725 106,489.612549 106,520.784314 C106,551.956078 131.318588,577.254902 162.514706,577.254902 L219.029412,577.254902 L219.029412,916.078431 L162.514706,916.078431 C131.318588,916.078431 106,941.377255 106,972.54902 C106,1003.72078 131.318588,1029.01961 162.514706,1029.01961 L219.029412,1029.01961 L219.029412,1367.84314 L162.514706,1367.84314 C131.318588,1367.84314 106,1393.14196 106,1424.31373 C106,1455.48549 131.318588,1480.78431 162.514706,1480.78431 L219.029412,1480.78431 L219.029412,1920 L1801.44118,1920 L1801.44118,0 L219.029412,0 Z M1179.60784,338.823529 L1179.60784,451.764706 L671.372549,451.764706 L671.372549,1129.41176 L1349.01961,1129.41176 L1349.01961,734.117647 L1461.96078,734.117647 L1461.96078,1242.35294 L558.431373,1242.35294 L558.431373,338.823529 L1179.60784,338.823529 Z M1386.93396,414.640941 L1466.78337,494.490353 L1034.33161,926.942118 L809.465725,701.963294 L889.315137,622.113882 L1034.33161,767.243294 L1386.93396,414.640941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconGradebookSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconGradebookSolid, _Component);

  var _super = _createSuper(IconGradebookSolid);

  function IconGradebookSolid() {
    _classCallCheck(this, IconGradebookSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconGradebookSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconGradebook",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconGradebookSolid.displayName = "IconGradebookSolid";
  return IconGradebookSolid;
}(Component);

IconGradebookSolid.glyphName = 'gradebook';
IconGradebookSolid.variant = 'Solid';
IconGradebookSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconGradebookSolid;
export { IconGradebookSolid };